var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElTooltip',_vm._b({attrs:{"content":_vm.content,"placement":"top","open-delay":_vm.openDelay}},'ElTooltip',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }